import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";

const Redirect: React.FC = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { jobId } = useParams();
  // const playMarketLink = `https://play.google.com/&jobId=${jobId}`;
  // const appStoreLink = `https://apps.apple.com/&jobId=${jobId}`;
  const playMarketLink = `https://play.google.com/store/apps/details?id=com.ctfieldservices.app/&jobId=${jobId}`;
  const appStoreLink = `  https://apps.apple.com/app/id6761888693/&jobId=${jobId}`;

  const isAndroid = useMemo(() => {
    if (typeof navigator === "undefined") return false;
    return navigator.userAgent.toLowerCase().includes("android");
  }, []);

  useEffect(() => {
    if (!isAndroid) return;

    const redirectTo = new URL(playMarketLink);

    const currentSearch = window.location.search;
    const urlParams = new URLSearchParams(currentSearch);

    if (currentSearch.includes("ref")) {
      urlParams.forEach((value, key) => {
        redirectTo.searchParams.append(key, value);
      });
    }

    window.location.href = redirectTo.toString();
  }, [isAndroid, playMarketLink]);

  const handleIosRedirect = async () => {
    if (!isChecked) {
      alert("Please check the checkbox to proceed.");
      return;
    }

    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch (error) {
      console.error("Failed to copy link:", error);
    } finally {
      window.location.href = new URL(appStoreLink).toString();
    }
  };

  return (
    <div id="app-container">
      <label>
        <input
          id="checkbox"
          type="checkbox"
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
        />
        I agree to proceed
      </label>

      <br />

      <button id="cat" type="button" onClick={handleIosRedirect}>
        Open App Store
      </button>
    </div>
  );
};

export default Redirect;
